import i18n from "i18next";

const getCancellationPolicyText = (cancellationPolicy) => {
  if (!cancellationPolicy) {
    return null;
  }

  const {
    cancellationPolicyLogic,
    cancellationPolicyDeadline,
    cancellationPolicyDeadlineType,
    cancellationPolicyPenalty,
    currency,
    cancellationPolicyMode,
    afterReservationCancellationLogic,
    afterReservationCancellationAmount,
    nonShowPolicy,
  } = cancellationPolicy;

  // Get the appropriate non-show text
  const nonShow = i18n.t(
    nonShowPolicy === "total_price"
      ? "cancellation_policies:non_show:total_price"
      : "cancellation_policies:non_show:follow_conditions",
  );

  if (cancellationPolicyLogic === "free" && afterReservationCancellationLogic === "free") {
    return i18n.t("cancellation_policies:free_cancellation:anytime") + " " + nonShow;
  }
  if (
    cancellationPolicyLogic === "free" &&
    afterReservationCancellationLogic === "non_refundable"
  ) {
    return i18n.t("cancellation_policies:non_refundable:full") + " " + nonShow;
  }

  if (cancellationPolicyLogic === "free" && afterReservationCancellationLogic === "nights_based") {
    return (
      i18n.t("cancellation_policies:penalties:nights_based", {
        amount: afterReservationCancellationAmount,
      }) +
      " " +
      nonShow
    );
  }

  if (
    cancellationPolicyLogic === "free" &&
    afterReservationCancellationLogic === "gurantee_amount"
  ) {
    return (
      i18n.t("cancellation_policies:free_cancellation:anytime") +
      " " +
      i18n.t("cancellation_policies:guarantee:non_refundable") +
      " " +
      nonShow
    );
  }
  if (cancellationPolicyLogic === "free" && afterReservationCancellationLogic === "percent_based") {
    return (
      i18n.t("cancellation_policies:penalties:percent_based", {
        amount: afterReservationCancellationAmount,
      }) +
      " " +
      nonShow
    );
  }
  if (
    cancellationPolicyLogic === "non_refundable" &&
    afterReservationCancellationLogic === "free"
  ) {
    return (
      i18n.t("cancellation_policies:free_cancellation:with_deadline", {
        deadline: cancellationPolicyDeadline,
      }) +
      " " +
      i18n.t("cancellation_policies:non_refundable:with_deadline") +
      " " +
      nonShow
    );
  }

  if (
    cancellationPolicyLogic === "deadline" &&
    afterReservationCancellationLogic === "free" &&
    cancellationPolicyMode === "percent"
  ) {
    return (
      i18n.t("cancellation_policies:free_cancellation:with_deadline", {
        deadline: cancellationPolicyDeadline,
      }) +
      " " +
      i18n.t("cancellation_policies:penalties:percent_fee", {
        penalty: cancellationPolicyPenalty,
      }) +
      " " +
      nonShow
    );
  }

  if (
    cancellationPolicyLogic === "deadline" &&
    afterReservationCancellationLogic === "free" &&
    cancellationPolicyMode === "nights"
  ) {
    return (
      i18n.t("cancellation_policies:free_cancellation:with_deadline", {
        deadline: cancellationPolicyDeadline,
      }) +
      " " +
      i18n.t("cancellation_policies:penalties:nights_fee", { penalty: cancellationPolicyPenalty }) +
      " " +
      nonShow
    );
  }
  if (
    cancellationPolicyLogic !== "free" &&
    afterReservationCancellationLogic === "non_refundable"
  ) {
    return (
      i18n.t("cancellation_policies:non_refundable:full") +
      i18n.t("cancellation_policies:non_refundable:deadline_applicable", {
        deadline: cancellationPolicyDeadline,
      }) +
      " " +
      nonShow
    );
  }

  if (
    cancellationPolicyLogic === "non_refundable" &&
    afterReservationCancellationLogic === "guarantee_amount"
  ) {
    return (
      i18n.t("cancellation_policies:guarantee:non_refundable") +
      " " +
      i18n.t("cancellation_policies:non_refundable:deadline_applicable", {
        deadline: cancellationPolicyDeadline,
      }) +
      " " +
      i18n.t("cancellation_policies:non_refundable:with_deadline") +
      " " +
      nonShow
    );
  }

  if (
    cancellationPolicyLogic === "deadline" &&
    afterReservationCancellationLogic === "guarantee_amount" &&
    cancellationPolicyMode === "percent"
  ) {
    return (
      i18n.t("cancellation_policies:guarantee:non_refundable") +
      " " +
      i18n.t("cancellation_policies:non_refundable:deadline_applicable", {
        deadline: cancellationPolicyDeadline,
      }) +
      " " +
      i18n.t("cancellation_policies:penalties:percent_fee", {
        penalty: cancellationPolicyPenalty,
      }) +
      " " +
      nonShow
    );
  }

  if (
    cancellationPolicyLogic === "deadline" &&
    afterReservationCancellationLogic === "guarantee_amount" &&
    cancellationPolicyMode === "nights"
  ) {
    return (
      i18n.t("cancellation_policies:guarantee:non_refundable") +
      " " +
      i18n.t("cancellation_policies:non_refundable:deadline_applicable", {
        deadline: cancellationPolicyDeadline,
      }) +
      " " +
      i18n.t("cancellation_policies:penalties:nights_fee", { penalty: cancellationPolicyPenalty }) +
      " " +
      nonShow
    );
  }

  if (
    cancellationPolicyLogic === "non_refundable" &&
    afterReservationCancellationLogic === "nights_based"
  ) {
    return (
      i18n.t("cancellation_policies:penalties:nights_based", {
        amount: afterReservationCancellationAmount,
      }) +
      " " +
      i18n.t("cancellation_policies:non_refundable:deadline_applicable", {
        deadline: cancellationPolicyDeadline,
      }) +
      " " +
      i18n.t("cancellation_policies:non_refundable:with_deadline") +
      " " +
      nonShow
    );
  }

  if (
    cancellationPolicyLogic === "deadline" &&
    afterReservationCancellationLogic === "nights_based" &&
    cancellationPolicyMode === "nights"
  ) {
    return (
      i18n.t("cancellation_policies:penalties:nights_based", {
        amount: afterReservationCancellationAmount,
      }) +
      " " +
      i18n.t("cancellation_policies:non_refundable:deadline_applicable", {
        deadline: cancellationPolicyDeadline,
      }) +
      " " +
      i18n.t("cancellation_policies:penalties:nights_fee", { penalty: cancellationPolicyPenalty }) +
      " " +
      nonShow
    );
  }
  if (
    cancellationPolicyLogic === "deadline" &&
    afterReservationCancellationLogic === "nights_based" &&
    cancellationPolicyMode === "percent"
  ) {
    return (
      i18n.t("cancellation_policies:penalties:nights_based", {
        amount: afterReservationCancellationAmount,
      }) +
      " " +
      i18n.t("cancellation_policies:non_refundable:deadline_applicable", {
        deadline: cancellationPolicyDeadline,
      }) +
      " " +
      i18n.t("cancellation_policies:penalties:percent_fee", {
        penalty: cancellationPolicyPenalty,
      }) +
      " " +
      nonShow
    );
  }

  if (
    cancellationPolicyLogic === "non_refundable" &&
    afterReservationCancellationLogic === "percent_based"
  ) {
    return (
      i18n.t("cancellation_policies:penalties:percent_based", {
        amount: afterReservationCancellationAmount,
      }) +
      " " +
      i18n.t("cancellation_policies:non_refundable:deadline_applicable", {
        deadline: cancellationPolicyDeadline,
      }) +
      " " +
      i18n.t("cancellation_policies:non_refundable:with_deadline") +
      " " +
      nonShow
    );
  }

  if (
    cancellationPolicyLogic === "deadline" &&
    afterReservationCancellationLogic === "percent_based" &&
    cancellationPolicyMode === "percent"
  ) {
    return (
      i18n.t("cancellation_policies:penalties:percent_based", {
        amount: afterReservationCancellationAmount,
      }) +
      " " +
      i18n.t("cancellation_policies:non_refundable:deadline_applicable", {
        deadline: cancellationPolicyDeadline,
      }) +
      " " +
      i18n.t("cancellation_policies:penalties:percent_fee", {
        penalty: cancellationPolicyPenalty,
      }) +
      " " +
      nonShow
    );
  }
  if (
    cancellationPolicyLogic === "deadline" &&
    afterReservationCancellationLogic === "percent_based" &&
    cancellationPolicyMode === "nights"
  ) {
    return (
      i18n.t("cancellation_policies:penalties:percent_based", {
        amount: afterReservationCancellationAmount,
      }) +
      " " +
      i18n.t("cancellation_policies:non_refundable:deadline_applicable", {
        deadline: cancellationPolicyDeadline,
      }) +
      " " +
      i18n.t("cancellation_policies:penalties:nights_fee", { penalty: cancellationPolicyPenalty }) +
      " " +
      nonShow
    );
  }
};

export default getCancellationPolicyText;
